import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// Every routes.js in vue-ocom and in the app (Vite's version of webpack's require.context)
const ocomRouteModules = import.meta.glob("./vue-ocom/**/routes.js", {
  eager: true,
});
const appRouteModules = import.meta.glob("./app/**/routes.js", { eager: true });

function mergeAppRoutes() {
  //Merges all routes.js files in the project!
  let routes = [];

  // Load vue-ocom shared routes first (auth, reports, user management, etc.)
  Object.values(ocomRouteModules).forEach((mod) => {
    routes = routes.concat(mod.default);
  });

  // Then the app's own routes (vue-router puts the catch-all * route last)
  Object.values(appRouteModules).forEach((mod) => {
    routes = routes.concat(mod.default);
  });

  return routes;
}

const routes = mergeAppRoutes();

export default new VueRouter({
  base: import.meta.env.BASE_URL,
  routes,
});

export { routes };
